import styled from 'styled-components'

import { BodyText } from '@/ui/atoms/body-text'

export const ReadMoreBodyText = styled(BodyText)`
  display: inline;
`
